import { render, staticRenderFns } from "./FDRate.vue?vue&type=template&id=2afd9239"
import script from "./FDRate.vue?vue&type=script&lang=js"
export * from "./FDRate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports